import React, { FC, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { ImageBlotProps } from '@components/TextEditor/Blots/ImageBlot/ImageBlotProps';
import { CropInput, FigureVersion } from '@graphql/types';
import { useStore } from '@stores/rootStoreContext';
import { SimpleFigure } from '@components/UI/Icons/simpleFigure';
import { EDITOR_CONSTS } from './Editor.consts';
import {
  DescriptionWrapper,
  SelectRegionWrapper,
  EditorWrapper,
  ImagePreviewWrapper,
  ImageTooltipWrapper,
  MainInformationWrapper,
  SimpleFigureWrapper,
  StoryInfoWrapper,
  TitleWrapper,
} from './Editor.styles';
import { EditorProps } from './EditorProps';
import { useFormContext, useWatch } from 'react-hook-form';

const Views: FC<EditorProps> = ({ figureTypeSlug }) => {
  const { cropperStore } = useStore();
  const { cropper, setCropper } = cropperStore;
  const [blockImage, setBlockImage] = useState<ImageBlotProps>(EDITOR_CONSTS.defaultImage);
  const { control } = useFormContext();
  const fields = useWatch({ control });
  const [figureVersion, setFigureVersion] = useState({} as FigureVersion);

  useEffect(() => {
    setFigureVersion(fields.figureVersion);
    setCropper((fields.figureVersion?.crop as CropInput) || null);
    setBlockImage({
      id: 'storyView' + fields.figureVersion?.figure?.id || '',
      src: fields.figureVersion?.primaryProcessedImage?.url || fields.figureVersion?.figure?.latestVersion?.primaryProcessedImage?.url || '',
      cropperPreviewUrl: fields.figureVersion?.figure?.cropperPreview?.url || '',
      crop: {
        width: cropper.width,
        height: cropper.height,
        top: cropper.top,
        left: cropper.left,
      },
      figureId: fields.figureVersion?.figure?.id || '',
      figureUid: fields.figureVersion?.figure?.uid || '',
      figureVersionId: fields.figureVersion?.id || '',
      isFullWidth: true,
      isannouncingphoto: false,
      isoverviewblock: false,
      hasWatermark: false,
      hasDiagonalWatermark: false,
    });
  }, [fields.figureVersion, setCropper, cropper]);

  return (
    <EditorWrapper>
      <MainInformationWrapper>
        <ImagePreviewWrapper>
          <div id="story-view-image">
            {fields.figureVersion?.primaryProcessedImage?.url ||
            fields.figureVersion?.figure?.latestVersion?.primaryProcessedImage?.url ? (
              <figure {...blockImage}>
                <img
                  className="story-view-image-preview"
                  src={
                    fields.figureVersion?.primaryProcessedImage?.url ||
                    fields.figureVersion?.figure?.latestVersion?.primaryProcessedImage?.url ||
                    '/noPhoto.jpg'
                  }
                  draggable="false"
                />
              </figure>
            ) : (
              <SimpleFigureWrapper>
                <SimpleFigure
                  width="27px"
                  height="24px"
                  viewBox="0 0 48 48"
                  color="primary"
                  style={{
                    margin: '6px 4.5px',
                  }}
                />
                <ImageTooltipWrapper>
                  <Typography variant="text16M">{EDITOR_CONSTS.imageNotExists}</Typography>
                </ImageTooltipWrapper>
              </SimpleFigureWrapper>
            )}
          </div>
        </ImagePreviewWrapper>
        <StoryInfoWrapper>
          <TitleWrapper>
            <Typography variant="h6" component="div">
              {fields.title || 'Без заголовка'}
            </Typography>
          </TitleWrapper>
          <DescriptionWrapper>
            <Typography variant="body1" component="div">
              {fields.description || 'Без описания'}
            </Typography>
          </DescriptionWrapper>
        </StoryInfoWrapper>
      </MainInformationWrapper>
    </EditorWrapper>
  );
};

export default observer(Views);